import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import './index.css';

console.log('[Main] Application starting...');

// Initialize analytics asynchronously
const trackingId = import.meta.env['VITE_GA_TRACKING_ID'];
const analyticsEnabled = import.meta.env['VITE_ANALYTICS_ENABLED'] !== 'false';
const debugMode = import.meta.env['VITE_ANALYTICS_DEBUG'] === 'true';

console.log('[Analytics] Config:', { trackingId, analyticsEnabled, debugMode });

if (trackingId && analyticsEnabled) {
  import('./services/analytics')
    .then(({ initializeAnalytics }) => {
      console.log('[Analytics] Module loaded, initializing...');
      return initializeAnalytics({
        trackingId,
        enabled: analyticsEnabled,
        debugMode,
        respectDNT: true,
      });
    })
    .then(() => {
      console.log('[Analytics] Initialized successfully');
    })
    .catch((err) => {
      console.error('[Analytics] Initialization failed:', err);
    });
} else {
  console.log('[Analytics] Skipped - missing tracking ID or disabled');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
